<template>
  <div>
    <v-card class="elevation-7 card-style">
      <v-card-title primary-title class="justify-center">
        <v-layout row wrap justify-center>
          <v-flex xs12 md6 lg7>
            <v-img src="@/assets/logo.png"></v-img>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-title primary-title class="justify-center">
        <div class="display-1 grey--text text--darken-3 font-weight-light">
          {{ $t("register.title") }}
        </div>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-form ref="form" onsubmit="return false;">
          <v-text-field
            autofocus
            color="blue"
            :label="$t('rms.field.name.label')"
            name="name"
            placeholder="My name"
            prepend-icon="person"
            type="text"
            v-model="register.data.name"
            :rules="[rules.required, rules.min_length(3)]"
          ></v-text-field>

          <v-text-field
            id="email"
            color="blue"
            :label="$t('rms.field.email.label')"
            name="email"
            placeholder="example@mail.com"
            :rules="[rules.required, rules.email]"
            prepend-icon="email"
            type="text"
            v-model="register.data.email"
            @keyup.enter="onRegister()"
          ></v-text-field>

          <v-text-field
            v-if="otp.active"
            id="otp"
            color="blue"
            :label="$t('rms.field.otp.label')"
            name="otp"
            :rules="[rules.required, rules.numeric, rules.exact_length(4)]"
            prepend-icon="$vuetify.icons.rms_otp"
            v-model="otp.value"
            persistent-hint
            :hint="$t('login.otp.sent.message')"
            @keyup.enter="verifyOtp()"
          ></v-text-field>
          <v-checkbox
            :rules="[rules.required]"
            class="justify-center"
            color="blue"
          >
            <template v-slot:label>
              <span>
                {{ $t("rms.field.register.tnc.label") }}
                <template>
                  <a
                    class="blue--text"
                    target="_blank"
                    :href="DEFINES.MOVIES_EVERYWHERE_TERMS_PAGE_LINK"
                    >{{ $t("rms.field.tnc.label") }}</a
                  >
                </template>
              </span>
            </template>
          </v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          v-if="register.button.active"
          v-on:click="onRegister"
          :loading="register.button.loading"
          color="blue"
          large
          :style="{ width: '30%' }"
          class="white--text"
          >{{ $t("rms.button.register") }}</v-btn
        >
        <v-btn
          v-if="otp.active"
          v-on:click="verifyOtp"
          :loading="otp.button.loading"
          color="blue"
          large
          :style="{ width: '30%' }"
          class="white--text"
          >{{ $t("rms.button.register") }}</v-btn
        >
      </v-card-actions>
      <v-card-actions class="justify-center pa-3">
        <span class="subheading blue--text">
          {{ $t("quickrights.login.message") }}
          <router-link to="/login" class="success--text">{{
            $t("quickrights.login_now.title")
          }}</router-link>
        </span>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState } from "vuex";
export default {
  data() {
    return {
      rules,
      register: {
        button: {
          active: true,
          loading: false,
        },
        data: {
          name: null,
          email: null,
        },
      },
      otp: {
        active: false,
        value: null,
        button: {
          loading: false,
        },
      },
    };
  },

  computed: {
    ...mapState({
      session_key: (state) => state.auth.key,
    }),
  },

  methods: {
    activeOtpField() {
      this.otp.active = true;
      this.register.button.active = false;
      this.register.button.loading = false;
      this.otp.value = "";
    },
    activeRegisterField() {
      this.otp.active = false;
      this.otp.button.loading = false;
      this.register.button.active = true;
      this.register.button.loading = false;
    },
    async onRegister() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.register.button.loading = true;
      try {
        var data = await this.$store.dispatch(
          "auth/register",
          this.register.data
        );
        this.activeOtpField();

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.otp.sent"),
          color: "success",
        });
      } catch (error) {
        this.activeRegisterField();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    // verifying otp
    async verifyOtp() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.otp.button.loading = true;
      try {
        var data = await this.$store.dispatch("auth/verifyOtp", {
          otp: this.otp.value,
          key: this.session_key,
        });
        this.otp.button.loading = false;
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.verified"),
          color: "success",
        });
        await this.$store.dispatch("auth/loginSuccess", data);
      } catch (error) {
        this.activeRegisterField();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>


<style  scoped>
.card-style {
  border-radius: 10px !important;
  border-top: 5px solid #2196f3 !important;
}
</style>
